module.exports = __webpack_public_path__ + "img/tilde-white.b706ff2.svg";